<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
                        Tempat Produksi
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
<!--        <div class="pembatas"></div>-->
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class=" animasi-card  bg-transparent d-flex mar-top-18 mar-bot-18">
                        <div class="font-16 status-login color-206CF" id="langkah2"><span class="font-weight-bold color-206CF">Langkah 3/4</span></div>
                    </div>
                    <div class="text-outlets mar-bot-18">
                        <div class="font-16">Masukkan data workshop sebagai tempat pengerjaan proses produksi</div>
                    </div>
                    <form action="">
                        <div class="form-group">
                            <label class="remove-margin require color-6f7 letter-space-002 font-14" for="namacreateworkshop">Nama Workshop</label>
                            <input type="text" class="form-control inputs color-0000" id="namacreateworkshop" aria-describedby="emailHelp" placeholder="Clean Laundry" v-model="dataProductionPlace.namaworkshop" v-on:keyup="inputnama">
	                        <ErrorMessage class="error" label="Nama Workshop" :validation="$v.dataProductionPlace.namaworkshop"></ErrorMessage>
	                        <label class="remove-margin mar-top-12 require color-6f7 letter-space-002 font-14" for="phone">Nomor Telpon Workshop</label>
                            <div class="input-group remove-padding">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">+62</div>
                                </div>
                                <input type="tel" class="form-control inputs color-0000" id="phone" placeholder="8176565733" v-on:keyup="nomorWaOnkeyupworkshop" v-model="dataProductionPlace.telpworkshop">
                            </div>
	                        <ErrorMessage class="error" label="Nomor Telepon Workshop" :validation="$v.dataProductionPlace.telpworkshop"></ErrorMessage>
                            <label class="remove-margin mar-top-12 require color-6f7 letter-space-002 font-14">Kota Workshop</label>
                            <Select2 class="test-select fl-is-required inputs mod" id="select2" v-on:change="cekValidate"  v-model="dataProductionPlace.selectedkota" :options="dataProductionPlace.optionskota"
                                     :settings="{ placeholder: 'Pilih Kota' }"
                                     @change="myChangeEvent($event);"/>
	                        <ErrorMessage class="error" label="Kota Workshop" :validation="$v.dataProductionPlace.selectedkota"></ErrorMessage>
                            <label class="remove-margin mar-top-12 require color-6f7 letter-space-002 font-14" for="alamat">Alamat Lengkap Workshop</label>
                            <textarea type="text" class="form-control inputs color-0000" id="alamat" aria-describedby="emailHelp"
                                      placeholder="Jln. Jendral Bersih Selalu No. 1" v-on:keyup="inputalamat" v-model="dataProductionPlace.alamatworkshop"></textarea>
	                        <ErrorMessage class="error" label="Alamat Workshop" :validation="$v.dataProductionPlace.alamatworkshop"></ErrorMessage>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long"  id="Btnplace" @click="cekconnection">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="this.dataProductionPlace.isClicked === true"></span><span id="textBtnplace">Berikutnya</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, maxLength, required} from "vuelidate/lib/validators";
    
    export default {
        name: "ProductionPlace",
        components: {Select2,ErrorMessage},
	    data() {
        	return {
		        requestHeaders: {
			        headers: {
				        'Authorization': 'Bearer ' + localStorage.getItem('token'),
			        }
		        },
	        }
	    },
	    validations: {
		    dataProductionPlace: {
			    namaworkshop: {
			    	required,
				    minLength: minLength(2),
			    },
			    telpworkshop: {
			    	required,
				    minLength: minLength(8),
				    maxLength: maxLength(12),
			    },
			    selectedkota: {
			    	required,
			    },
			    alamatworkshop: {
			    	required,
				    minLength: minLength(2),
			    }
		    }
	    },
        mounted(){
            this.getkotaa();
            this.cekValidate()

            this.backButtonPressed(this.back)
            this.smartTrackingView("add_outlet_step3");

        },
        props:["dataProductionPlace"],
        methods:{
            back(){
              this.$emit('showProductionProcess')
            },
            activity(){
                this.$emit('Activity')
            },
        myChangeEvent(val) {
            this.myValue = val
        },

            async cekconnection(){
            	if (this.$v.dataProductionPlace.$invalid) {
		            this.$v.dataProductionPlace.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    this.smartTrackingErrorValidate("add_outlet_step3",{"errorMsg":"Form belum dilengkapi"});
            		return
	            }
            	if (this.dataProductionPlace.telpworkshop == "" || this.dataProductionPlace.telpworkshop == "" || this.dataProductionPlace.selectedkota == "" || this.dataProductionPlace.alamatworkshop == "") {
		            this.$toast.error("Isi semua form")
            		$('#Btnplace').prop('disabled', false);
		            this.dataProductionPlace.isClicked= false
                    this.smartTrackingErrorValidate("add_outlet_step3",{"errorMsg":"Form belum dilengkapi"});
		            return
	            }
                $('#Btnplace').prop('disabled', true);
                this.dataProductionPlace.isClicked= true
                $('#textBtnplace').hide();
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#Btnplace').prop('disabled', false);
                            this.dataProductionPlace.isClicked= false
                            $('#textBtnplace').show();
                            this.activity()
                            this.smartTrackingClick("add_outlet_step4");
                        } else {
                        	this.$toast.error(response.data.msg)
                            $('#Btnplace').prop('disabled', false);
                            this.dataProductionPlace.isClicked= false
                            $('#textBtnplace').show();
                            this.smartTrackingErrorValidate("add_outlet_step3",{"errorMsg":response.data.msg});
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#Btnplace').prop('disabled', false);
	                this.dataProductionPlace.isClicked= false
	                $('#textBtnplace').show();
                }
            },

        async getkotaa() {
            try {
                const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta', this.requestHeaders)
                if (response.status === 200) {
                    var rawkota = response.data.data;
                    this.dataProductionPlace.optionskota.push({id: "", text: "Pilih Kota"})
                    for (var i = 0; i < rawkota.length; i++) {
                        this.dataProductionPlace.optionskota.push({id: rawkota[i].id, text: rawkota[i].nama})
                    }
                }
            } catch (e) {
            	this.$catch_error_response(e)
            }
        },
            cekValidate() {
            	return
                var kota = this.dataProductionPlace.selectedkota;
                var namaworkshop = this.dataProductionPlace.namaworkshop;
                var telp = this.dataProductionPlace.telpworkshop;
                var alamat= this.dataProductionPlace.alamatworkshop;
                var lenPass = namaworkshop.length;
                if (lenPass >= 2 && kota !== '1' && (telp.length >= 8 && telp.length <= 12) && alamat.length>=2) {
                    $('#Btnplace').prop('disabled', false);
                } else {
                    $('#Btnplace').prop('disabled', true);
                }
            },

            inputnama(event){
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z_.,' -]+/,'');
                this.dataProductionPlace.namaworkshop = handle;
                this.cekValidate()
            },

            inputalamat(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z_.,()/' -]+/,'');
                this.dataProductionPlace.alamatworkshop = number
                this.cekValidate()
            },

            nomorWaOnkeyupworkshop(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0,1);
                var firstTel = phoneField.substring(1,15);
                var secCar = phoneField.substring(0,2);
                var secTel = phoneField.substring(2,15);
                var thrdcar = phoneField.substring(0,12);
                var output

                if(frstCar == 0){
                    output = firstTel
                }else if(secCar == 62){
                    output = secTel
                }else{
                    output = thrdcar
                }

                var number = output.replace(/[^0-9]+/, '');
                this.dataProductionPlace.telpworkshop = number;
                this.cekValidate()
            },
    }
  }
</script>

<style scoped>

</style>